/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Organizationalunits1Inputs */

const en_nav_organizationalunits1 = /** @type {(inputs: Nav_Organizationalunits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizational Units`)
};

const de_nav_organizationalunits1 = /** @type {(inputs: Nav_Organizationalunits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationseinheiten`)
};

/**
* | output |
* | --- |
* | "Organizational Units" |
*
* @param {Nav_Organizationalunits1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_organizationalunits1 = /** @type {((inputs?: Nav_Organizationalunits1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Organizationalunits1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_organizationalunits1(inputs)
	return de_nav_organizationalunits1(inputs)
});
export { nav_organizationalunits1 as "nav_organizationalUnits" }